import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

export const ValueTagRoot = styled.span`
    align-items: center;
    background-color: ${theme.colors.background.subtle};
    border: 1px solid ${theme.colors.border.muted};
    border-radius: ${theme.radii[4]};
    box-sizing: border-box;
    display: inline-flex;
    flex: none;
    height: 20px;
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    padding: 1px 3px;
`;
